import React, { useRef } from "react";
import { styled } from "styled-components";
import emailjs from "@emailjs/browser";

//import "../../i18n";
import { useTranslation } from "react-i18next";


const Ask = () => {
  const form = useRef();



  const sendEmail = e => {
    e.preventDefault();

    emailjs.sendForm("service_n9gzs57", "template_jupf4ca", form.current, "icuAyWQ5RBBeLiH9_").then(
      result => {
        alert(t("success"));
        form.current.reset();
      },
      error => {
        console.log(error.text);
        alert(t("fail"));
      },
    );
  };

  const { t, i18n } = useTranslation();

  return (
    <form ref={form} onSubmit={sendEmail}>
      {/* <label>title</label>
      <p></p>
      <input type="text" name="title" />
      <p></p> */}
      
      <label>{t("email")}</label>
      <p></p>
      <input type="email" name="user_email" />
      <p></p>
      <label>{t("message")}</label>
      <p></p>
      <textarea name="message" rows="10" style={ {width : "100%" } }/>

      <p></p>
      <input type="submit" value={t("send")}  />
    </form>
    
  );
};

export default Ask;
